import React, { useState, useEffect } from "react";
import {
  theme,
  ConfigProvider,
  Row,
  Typography,
  Col,
  Card,
  Breadcrumb,
  Button,
  Steps,
  Flex,
  Spin,
  Form,
  Select,
  Input,
  DatePicker,
  Checkbox,
  Table
} from "antd";
import menuItems from "../../../config/data/menus.json";
import { useNavigate, Link } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import { useForm } from "antd/lib/form/Form";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import MainLayout from "../../../components/MainLayout";
import MessageForm from "./components/MessageForm";
import CampaignForm from "./components/CampaignForm";
import Preview from "./components/Preview";

const { Text, Title } = Typography;

function MainPage(props) {
  const navigate = useNavigate();

  function backOnClick() {
    navigate("/sya1400", { replace: true });
  }
  return (
    <div>
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginBottom: 25,
        }}>
        <Col>
          <Row style={{ marginBottom: 0, marginTop: 0 }}>
            <Title level={2} style={{ margin: 0 }}>
              {props.titleOfPage}
            </Title>
          </Row>
          <Breadcrumb style={{ marginBottom: 0 }}>
            <BreadcrumbItem>
              <Link to="/dashboard">Home</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/sya1400">SMS Campaigns</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Text>Add SMS Campaign</Text>
            </BreadcrumbItem>
          </Breadcrumb>
        </Col>

      </Card>
      <div>
        <AddSYA1400Form backOnClick={backOnClick} />
      </div>
    </div>
  )
}


const AddSYA1400 = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState("/sya1400");
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#2F172D");
  const [searchColorBgContainer, setSearchColorBgContainer] =
    useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("dark");
  const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
  const [logoDimensions, setLogoDimensions] = useState(100);
  const [menuSearchBarState, setMenuSearchBarState] = useState(false);
  const [menuSearchIconState, setMenuSearchIconState] = useState(true);
  const [switchLabelState, setSwitchLabelState] = useState(false);

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#2F172D");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  function onMenuSelect(menuItems) {
    // console.log(menuItems.key);
    setSelectedKey(menuItems.key);
    navigate(menuItems.key, { replace: false });
  }

  useEffect(() => {
    if (collapsed === true) {
      setLeftLayoutMargin(71);
      setLogoDimensions(50);
      setMenuSearchBarState(true);
      setMenuSearchIconState(false);
      setSwitchLabelState(true);
    } else {
      setLeftLayoutMargin(190);
      setLogoDimensions(100);
      setMenuSearchBarState(false);
      setMenuSearchIconState(true);
      setSwitchLabelState(false);
    }
  });

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: menuBG,
          },
          Menu: {
            darkItemBg: menuBG,
            darkSubMenuItemBg: "#241223",
          },
        },
      }}
    >
      <MainLayout
        collapsed={collapsed}
        searchColorBgContainer={searchColorBgContainer}
        theme={menuTheme}
        defaultSelectedKeys={selectedKey}
        items={menuItems}
        onClick={onMenuSelect}
        switchLabel={switchLabel}
        onSwitchClick={onSwitchClick}
        switchLabelColor={switchLabelColor}
        logoDimensions={logoDimensions}
        menuSearchBarState={menuSearchBarState}
        menuSearchIconState={menuSearchIconState}
        switchLabelState={switchLabelState}
        setCollapsed={setCollapsed}
        leftLayoutMargin={leftLayoutMargin}
        colorBgContainer={colorBgContainer}
      >
        <MainPage titleOfPage={"Add SMS Campaign"} />
      </MainLayout>
    </ConfigProvider>
  );
};

export const AddSYA1400Form = () => {
  const navigate = useNavigate();

  const [current, setCurrent] = useState(0);
  const [campaignValues, setCampaignValues] = useState([]);
  const [messageValues, setMessageValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});

  const onChange = (value) => {
    console.log("onChange:", value);
    setCurrent(value);
  };

  const onFinishCampaignForm = (values) => {
    setCampaignValues([...campaignValues, values]);
    setCurrent(current + 1);
  };

  const onFinishMessageForm = (values) => {
    setMessageValues([...messageValues, values]);
    setCurrent(current + 1);
  };

  const [form] = useForm();

  const forms = [
    <CampaignForm
      onFinish={onFinishCampaignForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData}
      form={form}
    />,
    <MessageForm
      onFinish={onFinishMessageForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData}
      form={form}
    />,

    <Preview formData={formData} />,
  ];

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/sya1400", { replace: false });
  }

  return (
    <>
      <Spin spinning={loading} size="large">
        <Row
        
        >
          <Col span={24}>

            {/*Interractive Section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: "0px 16px",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>

                {/* Navigation section */}
                <Card
                  style={{
                    width: "20%",
                    boxShadow: "0px 0px 20px 1px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                    overflow: "auto",
                    height: "50%",
                    position: "sticky",
                    top: "0",
                  }}
                >
                  <Steps
                    current={current}
                    onChange={onChange}
                    direction="vertical"
                    style={{ height: "300px" }}
                    items={[
                      {
                        title: <Text strong>Campaign</Text>,
                      },
                      {
                        title: <Text strong>Message</Text>,
                      },
                      {
                        title: <Text strong>Preview</Text>,
                      },
                    ]}
                  />
                </Card>
                {/* Form Section */}
                <Card
                  style={{
                    marginLeft: "auto",
                    width: "75%",
                    // boxShadow: "0px 0px 30px 25px rgba(0,0,0,0.025)",
                    boxShadow: "0px 0px 20px 1px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                  }}
                >
                  <div>
                    {isLastStep ? (
                      <Preview formData={formData} />
                    ) : (
                      forms[current]
                    )}
                  </div>
                </Card>
              </Row>
            </Card>
          </Col>
        
        </Row>

        {/* Submit section */}
        <Card
          style={{
            marginBottom: 25,
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Flex
            justify="space-between"
            style={{ paddingLeft: "10px", paddingRight: "40px" }}
          >
            {current === 0 && (
              <Button
                style={{
                  width: "10%",
                  backgroundColor: "white",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  borderRadius: 20,
                }}
                colorText="black"
                onClick={onCancel}
              >
                Cancel
              </Button>
            )}
            {current > 0 && (
              <Button
                style={{
                  width: "10%",
                  backgroundColor: "#15CCAE",
                  color: "white",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  borderRadius: 20,
                }}
                onClick={prevButtonClick}
              >
                Prev
              </Button>
            )}
            {!isLastStep && (
              <Button
                style={{
                  width: "10%",
                  backgroundColor: "#15CCAE",
                  color: "white",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  borderRadius: 20,
                }}
                onClick={nextButtonClick}
              >
                Next
              </Button>
            )}
            {isLastStep && (
              <Button
                style={{
                  width: "10%",
                  backgroundColor: "white",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  borderRadius: 20,
                }}
              >
                Submit
              </Button>
            )}
          </Flex>
        </Card>
      </Spin>
    </>
  );
};

export default AddSYA1400;
